import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['elementToToggle'];

  toggle = () => {
    this.elementToToggleTarget.classList.toggle('vesta-display-none');
  }
}
